import React from "react";

interface BaseIconProps {
  isActive?: boolean;
  className?: string;
}

export default function BringToForwardIcon({
  isActive,
  className
}: BaseIconProps) {
  return (
    <svg
      width="40"
      height="40"
      className={className}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.1257 28V31C14.1257 32.3261 14.6274 33.5979 15.5204 34.5355C16.4135 35.4732 17.6247 36 18.8876 36H30.3162C31.5791 36 32.7903 35.4732 33.6834 34.5355C34.5764 33.5979 35.0781 32.3261 35.0781 31V19C35.0781 17.6739 34.5764 16.4021 33.6834 15.4645C32.7903 14.5268 31.5791 14 30.3162 14H27.459V16H30.3162C31.0739 16 31.8007 16.3161 32.3365 16.8787C32.8723 17.4413 33.1733 18.2044 33.1733 19V31C33.1733 31.7956 32.8723 32.5587 32.3365 33.1213C31.8007 33.6839 31.0739 34 30.3162 34H18.8876C18.1299 34 17.4031 33.6839 16.8673 33.1213C16.3315 32.5587 16.0305 31.7956 16.0305 31V28H14.1257ZM4.6019 9C4.6019 7.67392 5.1036 6.40215 5.99663 5.46447C6.88966 4.52678 8.10087 4 9.3638 4H20.7924C22.0553 4 23.2665 4.52678 24.1596 5.46447C25.0526 6.40215 25.5543 7.67392 25.5543 9V21C25.5543 22.3261 25.0526 23.5979 24.1596 24.5355C23.2665 25.4732 22.0553 26 20.7924 26H9.3638C8.10087 26 6.88966 25.4732 5.99663 24.5355C5.1036 23.5979 4.6019 22.3261 4.6019 21V9Z"
        fill={isActive ? "#663399" : "#000"}
      />
    </svg>
  );
}
